import { FC } from 'react';

import { DIVIDERS } from '.';
import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

interface Props {
  image: ImageData;
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  multipleVariations?: boolean;
}

const SettingsModal: FC<Props> = ({ multipleVariations, image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={withWatermarkDefaults(image)}
    title="Image Parameters"
    sections={[
      ...WATERMARK_SECTIONS,
      {
        title: 'Text Parameters',
        type: 'checkbox',
        stateKey: '',
        checkboxes: [
          { key: 'quotes', label: 'Quotes' },
          { key: 'brakes', label: 'Custom brakes' },
        ],
        show: multipleVariations,
      },
      {
        title: 'Cover Divider',
        type: 'radio',
        stateKey: 'divider',
        options: DIVIDERS,
      },
      {
        title: 'Font Size',
        type: 'input',
        stateKey: 'fontSize',
        inputType: 'number',
        placeholder: 'Font Size (px)',
        show: multipleVariations,
      },
    ]}
  />
);

export default SettingsModal;
